import { formatDistanceToNow } from 'date-fns'
import { ActiveFeedStatus } from '../types'

export const nextUpdateDisplayLabel = ( status?: ActiveFeedStatus | null ): string => {
	let displayText = 'Next Update:'

	if ( !status ) {
		return displayText
	}

	switch ( status ) {
	case ActiveFeedStatus.DELAYED:
	case ActiveFeedStatus.UNRESPONSIVE:
		displayText = 'Next Attempt:'
		break
	case ActiveFeedStatus.PENDING:
		displayText = 'First Update:'
		break
	default:
		displayText = 'Next Update:'
		break
	}
	return displayText
}


export const nextUpdateDisplayValue = ( status?: ActiveFeedStatus | null, time?: string | null, refreshInterval?: number | null ): string => {
	let displayValue = '--'

	if ( time ) {
		displayValue = formatDistanceToNow( new Date( time ), { addSuffix: true } )
	} else if ( status === ActiveFeedStatus.PENDING && refreshInterval ) {
		displayValue = `Within the next ${refreshInterval} minutes`
	}

	return displayValue
}
